"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const redux_1 = require("redux");
const assets_1 = require("~/assets");
const UI_1 = require("~/components/UI");
const DeletionConfirmationModal_1 = __importDefault(require("~/components/WidgetsManager/RecommendedFastenersWidget/DeletionConfirmationModal"));
const actions_1 = require("~/store/actions");
const events_1 = require("~/utils/events");
const Address_1 = __importDefault(require("../Address"));
const AddressesBlock_module_scss_1 = __importDefault(require("./AddressesBlock.module.scss"));
function AddressesBlock({ addressesArr, setEditMode, setSelectedAddressId }) {
    const { t } = (0, react_i18next_1.useTranslation)('quote-widget');
    const { dispatchDeleteAddress } = (0, redux_1.bindActionCreators)({ dispatchDeleteAddress: actions_1.deleteAddress }, (0, react_redux_1.useDispatch)());
    return (react_1.default.createElement("div", { className: AddressesBlock_module_scss_1.default.addresses },
        react_1.default.createElement("div", { className: AddressesBlock_module_scss_1.default.title, onClick: () => setEditMode === null || setEditMode === void 0 ? void 0 : setEditMode(true) },
            t('title.shipping-to-address'),
            react_1.default.createElement("img", { src: assets_1.svgBasicAddNewDark, alt: "plus sign" })),
        react_1.default.createElement("div", { className: AddressesBlock_module_scss_1.default.block }, addressesArr
            ? addressesArr.map((address) => {
                return (react_1.default.createElement("div", { className: AddressesBlock_module_scss_1.default.address, key: address.id },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(Address_1.default, { address: address })),
                    react_1.default.createElement("span", { className: AddressesBlock_module_scss_1.default.dots },
                        react_1.default.createElement(UI_1.ElementDropdown, { element: react_1.default.createElement("img", { src: assets_1.svgBasicDragIcon, alt: "" }), dropdown: react_1.default.createElement("div", { className: AddressesBlock_module_scss_1.default.dropdown },
                                react_1.default.createElement("a", { onClick: () => {
                                        if (setSelectedAddressId && setEditMode) {
                                            setEditMode(true);
                                            setSelectedAddressId(address.id);
                                        }
                                    } }, t('title.edit-address')),
                                react_1.default.createElement("a", { onClick: () => (0, events_1.showModal)(react_1.default.createElement(DeletionConfirmationModal_1.default, { onSubmit: () => dispatchDeleteAddress(address.id), middleOfTitle: "Ship to Adress", endOfTitle: "" })) }, t('title.delete-address'))), placement: "left-start" }))));
            })
            : null)));
}
exports.default = AddressesBlock;
